import { gql } from '@apollo/client';

export const GET_BATCH_REPORT_DOWNLOAD_URLS = gql`
  query ReportQuery($reportIds: [Long!]!) {
    getBatchReportDownloadUrls(reportIds: $reportIds)
  }
`;

export interface GetBatchReportDownloadUrlsResponse {
  getBatchReportDownloadUrls: string[];
}

export interface GetBatchReportDownloadUrlsVariables {
  reportIds: number[];
}